import type { ReactNode } from "react";
import { PageMetaData } from "@/react/components/Layout/PageMetaData";
import { SetLayoutConfig } from "@/react/components/SettingsApp/Layout/SetLayoutConfig";
import { StandardLayoutHeaderContainer } from "@circle-react/components/Layout/StandardLayoutV2/StandardLayoutHeaderContainer";

export interface NewPlansPageHeaderProps {
  pageTitle: string;
  layoutConfigProps?: any;
  pageMetaProps?: any;
  rightContent?: ReactNode;
  leftContent?: ReactNode;
  filters?: ReactNode;
  headline?: ReactNode;
  hasBorder?: boolean;
  children?: ReactNode;
}

export const NewPlansPageHeader = ({
  pageTitle,
  layoutConfigProps,
  pageMetaProps,
  children,
}: NewPlansPageHeaderProps) => (
  <>
    <PageMetaData title={pageTitle} {...pageMetaProps} />
    <SetLayoutConfig disableRightSidebar={false} {...layoutConfigProps} />

    <StandardLayoutHeaderContainer>{children}</StandardLayoutHeaderContainer>
  </>
);
